/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

import { DateComponent } from '../../common/date/rt-date/date.component';

export class DateCellComponent extends DateComponent {
  public static NgInputs = ['time' as const, 'tooltipPosition' as const];
}
